import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';

export const animations = {
  menuDeploy: trigger('deploy', [
    state('close', style({
      opacity: 0,
      height: 0,
      display: 'none',
    })),
    state('open', style({
      opacity: 1,
    })),
    transition('close <=> open', animate(150)),
  ]),
  bgOpacity: trigger('bgDeploy', [
    transition(
      ':enter',
      [
        style({ opacity: 0}),
        animate('200ms ease-in-out', style({ opacity: 1}))
      ]
    ),
    transition(
      ':leave',
      [
        style({ opacity: 1 }),
        animate('200ms ease-in-out', style({ opacity: 0}))
      ]
    ),
  ]),
  menuSlide: trigger('menuSlide', [
    transition(
      ':enter',
      [
        style({ opacity: 0, width: 0}),
        animate('250ms ease-in-out', keyframes([
          style({ width: '*'}),
          style({ opacity: 1})
          ])
        )
      ]
    ),
    transition(
      ':leave',
      [
        style({ opacity: 1, width: '*' }),
        animate('250ms ease-in-out', keyframes([
          style({ opacity: 0}),
          style({ width: 0})
          ])
        )
      ]
    ),
  ])
}
